/**
 * Utilities for the geo page
 */
import store from '@/store'

/**
 * service_name/geo_id(/{stg_slug}(/{st_slug}))
 * e.g.
 * service_name/california/utilities/electric
 * service_name/1,2,3,4/utilities/electric where "1,2,3,4" is the lat/lon bounds of the geo
 *
 */
function apiPath (route, service = '') {
  const p = route.params
  const stgSlug = p.stg ? p.stg : ''
  const stSlug = p.st ? p.st : ''
  const geoId = p.geoId ? p.geoId : ''
  return `${service}/${geoId}${stgSlug ? '/' + stgSlug + (stSlug ? '/' + stSlug : '') : ''}`
}

function geoName () {
  const geo = store.state.heatmap.selectedGeo
  if (geo) {
    if (geo.slug === 'united-states-of-america') {
      return 'the USA'
    } else if (geo.type === 'GeoBounds') {
      return 'this area'
    } else {
      return geo.name ? geo.name : 'this area'
    }
  } else {
    return 'this area'
  }
}

function serviceTypeName () {
  const state = store.state.geo
  if (state.serviceType) {
    return state.serviceType.name
  }
  if (state.serviceTypeGroup) {
    return state.serviceTypeGroup.name
  }
  return ''
}

export { apiPath, geoName, serviceTypeName }



// WEBPACK FOOTER //
// ./frontend/src/pages/Geo/components/utils.js